
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype3On as ObiMosfetNtype3OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-3-on.js';
 
 
 

 
 export const ObiMosfetNtype3On = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-3-on',
   elementClass: ObiMosfetNtype3OnElement,
   events: {
     
   }
  });
 
 